module.exports = __webpack_public_path__ + "img/scotland.5d4972b0.png";